/**
 * Before creating a customer, check normalized phone duplicates and prompt the user.
 * @returns {{ proceed: boolean, allowDuplicate: boolean }}
 */
export async function resolveNewCustomerPhoneDuplicate({ api, phone, lang, confirm, excludeCustomerId }) {
  const trimmed = (phone || "").trim();
  if (!trimmed) {
    return { proceed: true, allowDuplicate: false };
  }
  const params = { phone: trimmed };
  if (excludeCustomerId) params.exclude_customer_id = excludeCustomerId;

  const r = await api.get("/customers/check-phone", { params });
  if (!r.data?.duplicate) {
    return { proceed: true, allowDuplicate: false };
  }

  const c = r.data.customer || {};
  const title = lang === "ar" ? "رقم الهاتف مسجل مسبقاً" : "Phone number already registered";
  const namePart = c.name || (lang === "ar" ? "عميل آخر" : "another customer");
  const phonePart = c.phone ? (lang === "ar" ? ` (${c.phone})` : ` (${c.phone})`) : "";
  const description = lang === "ar"
    ? `هذا الرقم مسجل بالفعل باسم «${namePart}»${phonePart}.\n\nاختر «رجوع» لتعديل الرقم، أو «حفظ على أي حال» لإنشاء سجل جديد (لن يتم دمج السجلات الحالية).`
    : `This number is already registered to ${namePart}${phonePart}.\n\nChoose Go Back to change the number, or Save anyway to create a new record (existing records are not merged).`;

  const saveAnyway = await confirm({
    title,
    description,
    confirmLabel: lang === "ar" ? "حفظ على أي حال" : "Save anyway",
    cancelLabel: lang === "ar" ? "رجوع" : "Go Back",
    variant: "primary",
    testId: "customer-duplicate-phone-dialog",
  });

  if (!saveAnyway) {
    return { proceed: false, allowDuplicate: false };
  }
  return { proceed: true, allowDuplicate: true };
}
